import type { Client } from '~/api/clients/types';

import { Icon } from '~/components';

import { iconChipStyle } from './ClientTypeIcon.css';

type Props = {
  clientType: Client['clientType'];
};

export const ClientTypeIcon = ({ clientType }: Props) => (
  <div className={iconChipStyle}>
    <Icon name={clientType === 'organisation' ? 'Company' : 'Person'} size={30} />
  </div>
);
